import Images from "@/assets/Images";
import useRoutesHandler from "@/Hooks/useRouteHandler";
import {
  DocumentTextIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { TBasicObject } from "@repo/api-services/API-TYPES";
import { Image } from "@repo/ui/index.tsx";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

const SelectTypeComponent = ({
  setStep,
}: {
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  //States
  const [selectedType, setSelectedType] = useState<TBasicObject>();

  //Hooks
  const { navigateTo } = useRoutesHandler();
  const { urlQueries } = useRoutesHandler();

  //Constant
  const types = [
    {
      id: 1,
      name: "Group",
      code: "group",
      description:
        "Group insurance products are designed for organizations, providing coverage like health or life insurance to employees or members under a single policy.",

      icon: RectangleStackIcon,
      iconClassName: "text-info bg-info/5",
    },
    {
      id: 2,
      name: "Retail",
      code: "retail",
      description:
        "Retail insurance products cater to individual customers, offering personalized policies such as health, property, or motor insurance for specific needs.",
      icon: DocumentTextIcon,
      iconClassName: "text-success bg-success/5",
    },
  ];

  useEffect(() => {
    const typeReset = types.find((typeUnit) => {
      return typeUnit.code === urlQueries["type"];
    });
    setSelectedType(typeReset);
  }, [urlQueries["type"]]);

  return (
    <div className="flex flex-col gap-10">
      <div className="">
        <p className="text-heading font-bold text-md">Choose Product Type</p>
        <p className="text-subHeading text-sm">
          Choose a product type to start creating a product.
        </p>
      </div>
      <div className="flex pb-10">
        <section className="w-52 flex items-center justify-center">
          <Image src={Images.nextStep} />
        </section>
        <div className="flex-1 flex flex-col gap-4 ">
          {types.map((type) => {
            return (
              <button
                key={type.id}
                type="button"
                data-isActive={selectedType?.id === type?.id}
                className="relative w-full items-center flex data-[isActive=true]:ring-primary/10 ring-extraLightGray 
              ring-2 rounded-lg overflow-hidden shadow-lg data-[isActive=true]:shadow-primary/10"
                onClick={() => {
                  navigateTo({ search: { type: String(type?.code) } });
                  setSelectedType(type);
                  setStep(2);
                }}
              >
                {selectedType?.id === type?.id && (
                  <CheckCircleIcon className="size-7 absolute right-2 top-2 text-primary" />
                )}
                <section
                  className={`h-full w-32 p-2 flex items-center justify-center bg-extraLightGray/30 ${type?.iconClassName}`}
                >
                  <type.icon className="size-8 " />
                </section>

                <section className="flex flex-col items-start pl-4 pr-10 py-2 ">
                  <h4 className="font-semibold text-subHeading">
                    {type?.name}
                  </h4>
                  <p className="text-[0.8rem] text-body text-left">
                    {type?.description}
                  </p>
                </section>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SelectTypeComponent;
